import type { TinyPayloads } from '@openeducation/pp-rn-shared-types';

export const getTotalAmountForInstallments = (
  tinyPayloads?: TinyPayloads
): number => {
  const isFirstSplitPayment =
    tinyPayloads?.invoiceSplitItems &&
    tinyPayloads?.invoiceSplitItems.length > 0;

  return (
    (isFirstSplitPayment && tinyPayloads.invoiceSplitItems?.[0]?.amount) ||
    tinyPayloads?.totalAmount ||
    0
  );
};
